// extracted by mini-css-extract-plugin
module.exports = {"wrap":"e_yT","trigger":"e_zT","tip":"e_AT","tipEnd":"e_BT","tipOpen":"e_CT","link":"e_DT"};